// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mbg3U","footer":"styles_footer__3iYmJ"};